import { render } from "./footer.vue?vue&type=template&id=0d78eaba&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=0d78eaba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d78eaba"],['__file',"src/components/parts/footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d78eaba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d78eaba', __exports__)) {
    api.reload('0d78eaba', __exports__)
  }
  
  module.hot.accept("./footer.vue?vue&type=template&id=0d78eaba&scoped=true", () => {
    api.rerender('0d78eaba', render)
  })

}


export default __exports__